import { Routes } from '@angular/router';
import { AuthGuard } from "./shared/gurads/auth.guard";

export const routes: Routes = [
  { path: '', redirectTo: '/pages', pathMatch: 'full' },
  {
    path: 'pages',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./core/core.module').then( m => m.CoreModule ),
  },
  { path: '**', redirectTo: '/pages/page-not-found' }
];
